import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import InternalTransfersListViewModel from "viewModels/finance/bankExports/internalTransfers/internalTransfersListViewModel";
import BankExportListView from "../bankExportListView";

const InternalTransferListView: ViewComponent<InternalTransfersListViewModel> = observer(({ vm }) => {
  return <BankExportListView vm={vm} />;
});

registerView(InternalTransferListView, InternalTransfersListViewModel);
